import { combineReducers } from 'redux';
import {
  REQUEST_LOGIN,
  REQUEST_LOGOUT,
  AUTH_GRANTED,
  AUTH_ERROR,
  REQUEST_LOGIN_RESET,
  REQUEST_ME,
  REQUEST_ME_ERROR,
  REQUEST_ME_SUCCESS,
  UPDATE_LOCALE_START,
  UPDATE_LOCALE_SUCCESS,
  UPDATE_LOCALE_ERROR,
  SKIP_LOGIN,
} from '../actions';

function loading(state = false, action) {
  switch (action.type) {
    case REQUEST_LOGIN:
    case REQUEST_ME:
    case UPDATE_LOCALE_START:
      return true;
    case REQUEST_LOGOUT:
    case AUTH_GRANTED:
    case AUTH_ERROR:
    case REQUEST_LOGIN_RESET:
    case REQUEST_ME_SUCCESS:
    case REQUEST_ME_ERROR:
    case UPDATE_LOCALE_SUCCESS:
    case UPDATE_LOCALE_ERROR:
      return false;
    default:
      return state;
  }
}

function user(state = null, action) {
  switch (action.type) {
    case AUTH_GRANTED:
      return {
        id: action.user.id,
        firstName: action.user.firstName,
        lastName: action.user.lastName,
        type: action.user.type,
        email: action.user.email,
        companyId: action.user.companyId,
        isClient: action.user.isClient,
      };
    case UPDATE_LOCALE_SUCCESS:
      return Object.assign({}, state, { locale: action.data });
    case REQUEST_LOGOUT:
    case REQUEST_ME_ERROR:
      return null;
    default:
      return Object.assign({}, state);
  }
}

function token(state = null, action) {
  switch (action.type) {
    case AUTH_GRANTED:
      return action.jwt;
    case AUTH_ERROR:
    case REQUEST_LOGOUT:
      return null;
    default:
      return state;
  }
}

function isAuthenticated(state = false, action) {
  switch (action.type) {
    case AUTH_GRANTED:
      return true;
    case AUTH_ERROR:
    case REQUEST_LOGOUT:
      return false;
    default:
      return state;
  }
}

function locale(state = 'it', action) {
  switch (action.type) {
    case AUTH_GRANTED:
    case SKIP_LOGIN:
      return action.user.locale;
    case REQUEST_ME_SUCCESS:
      return action.myData.locale;
    case UPDATE_LOCALE_SUCCESS:
      return action.data;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case REQUEST_LOGIN:
    case REQUEST_LOGIN_RESET:
    case REQUEST_ME:
    case REQUEST_ME_SUCCESS:
    case AUTH_GRANTED:
    case UPDATE_LOCALE_START:
    case UPDATE_LOCALE_SUCCESS:
      return null;
    case AUTH_ERROR:
    case REQUEST_ME_ERROR:
    case UPDATE_LOCALE_ERROR:
      return (action.err && action.err.message) || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

const authentication = combineReducers({
  loading,
  user,
  token,
  isAuthenticated,
  locale,
  error,
});

export default authentication;
